import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import {
  Card,
  Grid,
  Icon,
  Loader,
  Message,
  SemanticICONS,
} from "simplydo/react/ui";

import util from "utils/utils";

type OAuthConnectionType = { icon: SemanticICONS; name: string };

const types: Record<string, OAuthConnectionType> = {
  slack: { icon: "slack", name: "Slack" },
};

const OAuthConnection = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [type, setType] = useState<OAuthConnectionType | null>(null);

  const params = useParams();

  useEffect(() => {
    const connectionType = params.type;
    if (!types[connectionType]) {
      setErrorMessage("Connections with this service are not supported.");
    } else {
      const type = types[connectionType];
      setType(type);
      setLoading(true);
    }
  }, [params.type]);

  return (
    <Grid stackable centered style={{ marginTop: 40 }}>
      <Grid.Column computer={6} tablet={10}>
        <Card fluid color="yellow">
          {type && (
            <Card.Content textAlign="center" style={{ paddingTop: 20 }}>
              <Icon style={{ fontSize: 40 }} name={type.icon} />
              <h3 style={{ marginTop: 10 }}>
                Adding {type.name} to your {util.appName()} account...
              </h3>
            </Card.Content>
          )}
          {loading ?
            <Card.Content>
              <Loader active inline="centered" />
            </Card.Content>
          : null}
          {!loading && errorMessage ?
            <Card.Content>
              <Message error>{errorMessage}</Message>
            </Card.Content>
          : <React.Fragment>
              <Card.Content>
                <h2>Done</h2>
              </Card.Content>
            </React.Fragment>
          }
        </Card>
      </Grid.Column>
    </Grid>
  );
};

export default OAuthConnection;
